import React from 'react';
import styles from './sections.module.css';
import CTAGroup from '../CTAGroup';

/**
 * Four outcomes, kept to a phrase rather than a sentence so the first screen
 * on a phone stays scannable. The fourth is the living network — not automated
 * follow-up, which is still in development.
 */
const HERO_POINTS = [
  'Details that stay current',
  'Every meeting, remembered',
  'The right person, found fast',
  'A network that stays useful',
];

const HeroSection = () => (
  <section className={styles.hero}>
    <div className="vxm-grid-motif" />
    <span className={`vxm-glow ${styles.heroGlowGold}`} />
    <span className={`vxm-glow ${styles.heroGlowData}`} />

    <div className="vxm-container">
      <div className={styles.heroInner}>
        <p className="vxm-eyebrow">For professionals and teams</p>
        <h1 className="vxm-h1">
          Make every introduction count.
        </h1>
        <p className={`vxm-lead ${styles.heroLead}`}>
          Velox captures the people you meet, keeps their details current, and
          helps you remember, find and follow up, so a handshake becomes
          a relationship you can actually use.
        </p>

        <ul className={styles.heroPoints}>
          {HERO_POINTS.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>

        <CTAGroup source="hero" />

        <p className={styles.heroNote}>
          Share in person with a contactless card, or from your phone. Same
          platform.
        </p>
      </div>
    </div>
  </section>
);

export default HeroSection;
